export const pauseTime = 0.5;
export const animationTime = 2.5;
export const defaultFontValue = 'Open Sans';
export const defaultFontLabel = 'Open Sans';
export const defaultFontText =
  'ABCČĆDĐEFGHIJKLMNOPQRSŠTUVWXYZŽabcčćdđefghijklmnopqrsštuvwxyzžءيوهنملكقفغعظطضصشسزرذدخحجثتبأ1234567890١٢٣٤٥٦٧٨٩١٠‘?’“!”(%)[#]{@}/&<-+÷×=>®©$€£¥¢:;,.*؟،آإااإ';
export const minScaleValue = 10;
export const minTextScaleValue = 25;
export const minScaleValueAsPercentage = minScaleValue / 100;
export const minTextScaleValueAsPercentage = minTextScaleValue / 100;
export const elementSelectionPadding = 0;
export const canvasSizeDefault = 'landscape';
